import ProductTable from "../../components/Products/ProductTable";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function Product() {
  const { authState } = useSelector(
    (state) => state
  );
  const { loggedIn } = authState;
  const navigate = useNavigate();

  useEffect(() => {
    if(loggedIn != true){
      navigate("/signin")
    }
  },[loggedIn]);

  return (
    <div className="">
      <ProductTable />
    </div>
  );
}

export default Product;
